import { render, staticRenderFns } from "./RegisterCompo.vue?vue&type=template&id=81012e1c&scoped=true&"
import script from "./RegisterCompo.vue?vue&type=script&lang=js&"
export * from "./RegisterCompo.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCompo.vue?vue&type=style&index=0&id=81012e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81012e1c",
  null
  
)

export default component.exports